module.exports = __webpack_public_path__ + "img/modules-indoor-point.f5ee8fe8.jpg";